import React from "react";
import "./Topbar.css";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { motion } from "framer-motion";

const Topbar = () => {
  return (
    <motion.div
      className="topbar"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="topbar-left">
        <motion.span
          className="label"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Let’s Talk :
        </motion.span>
        <a href="tel:+919141007452">+91 63607 05213</a>
        <span className="divider" />
        <motion.span
          className="label"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          General Support :
        </motion.span>
        <a href="mailto:info@newzealacademy.com">info@newzealacademy.com</a>
      </div>

      <div className="topbar-right">
        {[
          { icon: <FaFacebookF />, link: "#" },
          { icon: <FaInstagram />, link: "#" },
          { icon: <FaTwitter />, link: "#" },
          { icon: <FaLinkedinIn />, link: "#" },
        ].map((item, index) => (
          <motion.a
            key={index}
            href={item.link}
            aria-label="social"
            className="social"
            whileHover={{ scale: 1.3, rotate: 10 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            {item.icon}
          </motion.a>
        ))}
      </div>
    </motion.div>
  );
};

export default Topbar;
